import PropTypes from 'prop-types';

export const locationPropType = PropTypes.shape({
  Id: PropTypes.number,
  ExpandedName: PropTypes.string,
  Type: PropTypes.string,
  CountryCode: PropTypes.string,
});
